import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './components/navBar';
import ScrollToTop from './components/ScrollToTop';

// Import your pages...
import Home from './routes/homepage';
import AboutUs from './routes/aboutUs';
import Programs from './routes/programs';
import Events from './routes/events';
import Resources from './routes/resources';
import Donate from './routes/donate';
import Footer from './components/footer';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen relative">
        <NavBar />
        <div className="pt-28 pb-12"> 
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/events" element={<Events />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/donate" element={<Donate />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;